<div class="section-title">
    <h4>{{title}}</h4>
  </div>
<div class="row" *ngFor="let job of jobs">
    <div class="col-12">
        <div class="job-list">
           
            <div class="job-list-details">
                <div class="job-list-info">
                    <div class="job-list-title text-start">
                        <h5 class="mb-0">
                            <a role="button" [routerLink]="" (click)="onViewJobClicked(job)">{{job.title}}</a>
                        </h5>
                    </div>
                    <div class="job-list-favourite-time d-flex align-items-center justify-content-between">
                        <!-- Logo on the left -->
                        <div class="job-list-logo">
                          <img class="img-fluid" [src]="job.businessLogo" alt="">
                        </div>
                      
                        <!-- Heart and expiry section on the right -->
                        <div class="d-flex flex-column align-items-end">
                          <a class="job-list-favourite" [ngClass]="{bookmarked: job.bookmarked === true}" [routerLink]="" (click)="onFavouriteClicked(job.id)">
                            <i class="far fa-heart"></i>
                          </a>
                          <span class="job-list-time mt-1">
                            <i class="far fa-clock pr-1"></i>{{ job.expiry }}
                          </span>
                        </div>
                      </div>
                      
                                
                  
                    <div class="job-list-option">
                        <ul class="list-unstyled">
                            <li><i class="fas fa-map-marker-alt pr-1"></i>{{job.city}}, {{job.country}}</li>
                            <li><i class="fas fa-filter pr-1"></i>{{job.sector}}</li>
                            <li><a class="freelance" href="#"><i
                                        class="fas fa-suitcase pr-1"></i>{{job.type}}</a></li>
                            <li><a class="freelance" href="#"><i
                                        class="fas flaticon-debit-card pr-1"></i>{{job.salaryRange}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="job-list-info col pt-2">
                  <div class="job-list-option">
                      <ul class="list-unstyled">
                          <li *ngIf="job.totalAmountSpent"><i
                            class="fas fa-money pr-1" title="Total Spent"></i>${{job.totalAmountSpent}} spent
                          </li>
                      </ul>
                  </div>
              </div>
            </div>
    
        </div>
    </div>
</div>
<div *ngIf="showPager" class="row">
    <pager [totalPageCount]="totalPageCount" (valueChange)="onPagerValueChanged($event)"></pager>
</div>